import React from 'react';
import { Box, Heading, Image, Center } from '@chakra-ui/react';
import WizardForm from './components/WizardForm';

function App() {
  return (
    <Box
      px={[2, 4, 8]}
      pt={[2, 4, 8]}
      pb={4}
      maxW="600px"
      mx="auto"
    >
      <Center mb={[2, 3, 4]} mt={2}>
        <Image
          src="/ACT_Logo.png"
          alt="Altitude Control Technology Company Logo"
          maxW={["220px", "260px", "320px"]} // Responsive width
          maxH={["60px", "80px", "100px"]}   // Responsive height
          objectFit="contain"
          mx="auto"
        />
      </Center>
      <Heading as="h1" size="lg" mb={4} textAlign="center">
        Customer Project Information Form
      </Heading>
      <WizardForm />
    </Box>
  );
}

export default App;
